module.exports = __webpack_public_path__ + "img/out-pic3.5295dd5d.png";